import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UploadService from "../../Services/FileUploadServices";

import { campaignAction } from "../../store/campaign-store";
import { cuteToast } from "../UI/cute";

const FileUpload = (props) => {
  const { toggleRightshow } = props;
  const dispatch = useDispatch();
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const single_layer = useSelector((state) => state.campaign.single_layer);

  const editSlideData = useSelector((state) => state.campaign.editSlideData);
  const active_slide_name = useSelector(
    (state) => state.campaign.active_slide_name
  );

  useEffect(() => {
    console.log(single_layer);
  }, [single_layer]);

  const inputFileRef = useRef(null);
  const token = useSelector((state) => state.auth.token);

  const onDivClick = () => {
    inputFileRef.current.click();
  };

  const onFileChange = (e) => {
    let currentFiles = e.target.files;
    setProgress(0);
    setCurrentFile(currentFiles);

    if (checkMimeType(e) && checkFileSize(e)) {
      console.log(single_layer.name);
      // if (single_layer.name.indexOf("bg_image") === 0) {
      //   const url = URL.createObjectURL(currentFiles[0]);
      //   dispatch(campaignAction.setImageEditor({ content: url }));
      //   toggleRightshow();
      //   // console.log(url);
      // } else {
      UploadService.upload(currentFiles[0], token, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
        .then((response) => {
          // console.log(response.status);

          if (single_layer.name.indexOf("bg_image") === 0) {
            // const url = URL.createObjectURL(currentFiles[0]);
            dispatch(
              campaignAction.setImageEditor({ content: response.data.url })
            );
            toggleRightshow();
            // console.log(url);
          } else {
            if (response.status === 200) {
              updateNewData(response.data.url);
            }
            e.target.value = null;
          }
        })
        .catch(() => {
          setProgress(0);
          // setMessage("Could not upload the file!");
          setCurrentFile(undefined);
        });
      // }

      // console.log(currentFileData);
    }
  };

  /* Check the 
        Image type 
          and 
        check Image File Size 
  */
  const checkMimeType = (event) => {
    //getting file object
    let files = event.target.files;
    //define message container
    let err = "";
    // list allow mime type
    const types = ["image/png", "image/jpeg"];
    // loop access array

    //    console.log(files.length);
    if (types.every((type) => files[0].type !== type)) {
      err += files[0].type + " is not a supported format\n";
    }

    if (err !== "") {
      // if message not same old that mean has error
      event.target.value = null; // discard selected file
      cuteToast({
        type: "error",
        message: `Trim Duration Should Be ${err}s`,
        timer: 5000,
        title: "Error",
      });
      return false;
    }
    return true;
  };

  const checkFileSize = (event) => {
    let files = event.target.files;
    let size = 4000000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      // console.log(files[x].size);
      if (files[x].size > size) {
        err += files[x].type + " is too large, please pick a smaller file\n";
      }
    }
    if (err !== "") {
      event.target.value = null;

      cuteToast({
        type: "error",
        message: `Trim Duration Should Be ${err}s`,
        timer: 5000,
        title: "Error",
      });

      return false;
    }

    return true;
  };
  /* End Image type and check Image File Size */

  const updateNewData = async (url) => {
    console.log(single_layer);
    // return false;
    let new_layer_data = { ...single_layer };
    new_layer_data.src = url;

    console.log(single_layer);
    // return false;

    await dispatch(campaignAction.setSingleLayerData({ data: new_layer_data }));

    await dispatch(
      campaignAction.setSingleSlideData({ layer_name: single_layer.name })
    );

    dispatch(campaignAction.appendVideoData());

    // if (
    //   active_slide_name === "slide_1" ||
    //   active_slide_name === "slide_2" ||
    //   active_slide_name === "slide_3"
    // ) {
    var newData = { ...editSlideData };

    newData.logo = url;
    dispatch(campaignAction.setSlideData({ data: newData }));
    // }

    dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: false }));

    toggleRightshow();
  };

  return (
    <>
      <div
        className="upload_thmnl mb-4 align-items-center uploadDiv text-center"
        onClick={onDivClick}
      >
        <p className="text-primary">
          <u>Click to upload image</u>
        </p>
        <p>
          <i>
            {(active_slide_name === "slide_40" ||
              active_slide_name === "slide_41" ||
              active_slide_name === "slide_42") && (
              <span>
                Image dimension <span className="text-success">(1100*650)</span>{" "}
                For better quality of video (Upload JPEG image for this slide)
              </span>
            )}

            {active_slide_name !== "slide_40" &&
              active_slide_name !== "slide_41" &&
              active_slide_name !== "slide_42" && (
                <span>
                  Image dimension{" "}
                  <span className="text-success">
                    {single_layer.name === "logo" ? "(220*60)" : "(1920*1080)"}
                  </span>{" "}
                  For better quality of video (Only PNG and JPEG images Allowed)
                </span>
              )}
          </i>
        </p>
        <br />
        <input
          name=""
          ref={inputFileRef}
          className="d-none"
          type="file"
          onChange={onFileChange}
        />
        {currentFile && (
          <div className="progress">
            <div
              className="progress-bar progress-bar-info progress-bar-striped"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: progress + "%" }}
            >
              {progress}%
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FileUpload;
